import React from 'react';
import { useParams } from 'react-router-dom';
// Components
import EventsTable from 'pages/Events/components/EventsTable/EventsTable';

const StoreTicketEvents = (): JSX.Element => {
  const { storeId } = useParams<{ storeId: string }>();

  return <EventsTable ownerId={storeId} />;
};

export default StoreTicketEvents;
